import { Paper } from '@mui/material';
import QRCode from 'react-qr-code';

interface SurveyQrCodeProps {
  url: string;
  size: number;
  variant?: 'elevation' | 'outlined';
  testId?: string;
}

const SurveyQrCode = ({ url, size, variant = 'elevation', testId }: SurveyQrCodeProps) => {
  return (
    <Paper
      aria-hidden
      elevation={0}
      variant={variant}
      test-id={testId}
      sx={{ backgroundColor: 'common.white', p: 1.5, lineHeight: 0 }}
    >
      <QRCode value={url} size={size} />
    </Paper>
  );
};

export default SurveyQrCode;
